import * as z from 'zod/mini'
import { queryArray } from '../../schemas/common'
import { ageRange, customerGroupFields } from '../../schemas/customer-group'

/**
 * The URL of a single group (`manage/entities/:entityId/customer-groups/:customerGroupId`). Only the
 * id `CustomerGroupGuard` looks up is declared; `:entityId` is checked by `ManagedEntityGuard`.
 */
export const customerGroupParams = z.object({ customerGroupId: z.uuid() })
export type CustomerGroupParams = z.infer<typeof customerGroupParams>

export const createCustomerGroupBody = z.object({ ...customerGroupFields }).check(z.superRefine(ageRange))
export type CreateCustomerGroupBody = z.infer<typeof createCustomerGroupBody>

// `z.partial` must wrap the object before the refinement - Zod refuses to derive from a refined object.
export const editCustomerGroupBody = z.partial(z.object({ ...customerGroupFields })).check(z.superRefine(ageRange))
export type EditCustomerGroupBody = z.infer<typeof editCustomerGroupBody>

export const addCustomersToGroupBody = z.object({
  customerIds: z.array(z.uuid()).check(z.minLength(1)),
})
export type AddCustomersToGroupBody = z.infer<typeof addCustomersToGroupBody>

export const removeCustomersFromGroupQuery = z.object({
  customerIds: queryArray(z.array(z.uuid()).check(z.minLength(1))),
})
export type RemoveCustomersFromGroupQuery = z.infer<typeof removeCustomersFromGroupQuery>
